import {getApiMetadata} from '../../helpers/api-metadata'
import {ContentType} from '../../platform/content-type'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import {ItemKeyType, type UpdateIssueStateRequest} from './contracts'

export async function apiUpdateSidePanelItemState(body: UpdateIssueStateRequest): Promise<void> {
  const apiData = getApiMetadata('memex-update-sidepanel-item-state-api-data')
  const url = new URL(apiData.url, window.location.origin)
  url.searchParams.set('kind', ItemKeyType.ISSUE)
  const {data} = await fetchJSON<UpdateIssueStateRequest, void>(url, {
    method: 'POST',
    body,
    token: apiData.token,
    contentType: ContentType.FormData,
  })
  return data
}
